const HORIZONTAL = 'horizontal';

const VERTICAL = 'vertical';

export { HORIZONTAL, VERTICAL };
